import stringFormatService from '../../services/stringFormatService';
import {config} from '../config';
import configGettersService from './configGettersService';

const getBannerLearnMoreUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.firmwareReleaseNotes.bannerLearnMoreUrl);

export default {
    getIsFirmwareReleaseNotesEnabled: () => config.data.firmwareReleaseNotes.isEnabled,
    getFirmwareReleaseNotesChangesIcons: () => config.data.firmwareReleaseNotes.changesIcons,
    getIsFirmwareReleaseNotesBannerEnabled: () => config.data.firmwareReleaseNotes.isBannerEnabled,
    getFirmwareReleaseNotesBannerLearnMoreUrl: () =>
        stringFormatService.getLanguageFormattedString(getBannerLearnMoreUrl()),
};
